import { render } from "./Inventory.vue?vue&type=template&id=2b39c8b4"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"
script.render = render

export default script